import {
  COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES, PERCENTAGES,
  BACKGROUND_IMAGE_POSITION
} from 'shared/constants';

const propsSchema = [
  {
    key: 'section_tag',
    label: 'Section Tag',
    type: types.TEXT
  },
  {
    key: 'text_animation',
    label: 'Text Animation',
    type: types.BOOLEAN
  },
  {
    key: 'play_on_enter',
    label: 'Start Play When Enters Viewport',
    type: types.BOOLEAN
  },
  {
    key: 'loop',
    label: 'Loop',
    type: types.BOOLEAN
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  },
  {
    key: 'bg_video',
    label: 'Background Video',
    type: types.OBJECT,
    options: false,
    children: [
      {
        key: 'url',
        label: 'Video Link',
        type: types.TEXT
      },
      {
        key: 'cover',
        label: 'Video Cover',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'bg_image',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES
      },
      {
        key: 'position',
        label: 'Background Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      }
    ]
  },
  {
    key: 'cta_block',
    label: 'CTA Block',
    type: types.OBJECT,
    option: false,
    children: [
      {
        key: 'section',
        label: 'Section Label',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'subtitle',
        label: 'Subtitle',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXT
      },
      {
        key: 'diagonals',
        label: 'Side Diagonal Lines',
        type: types.BOOLEAN
      },
      {
        key: 'buttons',
        label: 'Buttons',
        type: types.ARRAY,
        children: [
          {
            key: 'label',
            label: 'Button Label',
            type: types.TEXT
          },
          {
            key: 'url',
            label: 'URL',
            type: types.TEXT
          },
          {
            key: 'open_in_new_tab',
            label: 'Open in New Tab',
            type: types.BOOLEAN
          },
          {
            key: 'hide_for_blocked_areas',
            label: 'Hide for Blocked Areas',
            type: types.BOOLEAN
          }
        ]
      }
    ]
  },
  {
    key: 'socialLinks',
    label: 'Social Links',
    type: types.ARRAY,
    option: false,
    children: [
      {
        key: 'url',
        label: 'URL',
        type: types.TEXT
      },
      {
        key: 'icon',
        label: 'Icon',
        type: types.ICON
      }
    ]
  },
];

const defaultProps = {
  section_tag: 'FF 91',
  text_animation: false,
  play_on_enter: false,
  loop: true,
  color_theme: 'DARK',
  bg_image: {
    url: '',
    dark_overlay: 0,
    position: 'CENTER CENTER'
  },
  bg_video: {
    url: 'https://genesis-cdn.ff.com/homepage/01_marquee/genesis_ff91_emergence_3mbps.mp4',
    cover: 'https://genesis-cdn.ff.com/homepage/01_marquee/genesis_cover_image.jpg'
  },
  cta_block: {
    section: '',
    title: 'experience a new species',
    subtitle: '',
    description: '',
    diagonals: true,
    buttons: [
      {
        label: 'explore ff 91',
        url: '/ff-91',
        hide_for_blocked_areas: false
      },
      {
        label: 'preorder',
        url: '/reserve',
        hide_for_blocked_areas: false
      }
    ]
  },
  socialLinks: [
    { url: 'https://linkedin.com', icon: 'ff-icon-social-linkedin' },
    { url: 'https://youtube.com', icon: 'ff-icon-social-youtube' },
    { url: 'https://twitter.com', icon: 'ff-icon-social-twitter' },
    { url: 'https://facebook.com', icon: 'ff-icon-social-facebook' },
    { url: 'https://instagram.com', icon: 'ff-icon-social-instagram' }
  ],
};

export default {
  title: 'Hero Landing Section',
  id: 'HeroLanding',
  propsSchema,
  defaultProps
};
